/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class SelectItemsManagementModel extends JSONable {
  fieldName: string | undefined = undefined;

  value: string | undefined = undefined;

  label: string | undefined = undefined;

  locale: string | undefined = undefined;

  update(fieldName?: string, value?: string, label?: string, locale?: string) {
    this.fieldName = fieldName;
    this.value = value;
    this.label = label;
    this.locale = locale;
  }
}
